var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1386,
    height: 789,
    viewBox: "0 0 1386 789",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10033_38400)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1386,
    height: 789,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 594.5L505.755 609.807C565.51 625.114 685.021 655.727 804.531 628.303C924.042 600.878 1043.55 515.414 1163.06 471.025C1282.57 426.507 1402.08 423.191 1521.59 445.641C1641.1 468.218 1760.61 516.69 1820.37 540.926L1880.12 565.162V713.128H1820.37C1760.61 713.128 1641.1 713.128 1521.59 713.128C1402.08 713.128 1282.57 713.128 1163.06 713.128C1043.55 713.128 924.042 713.128 804.531 713.128C685.021 713.128 565.51 713.128 505.755 713.128H446V594.5Z",
    fill: "url(#paint0_linear_10033_38400)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1489 620.263L-1429.1 635.83C-1369.21 650.815 -1249.42 682.823 -1129.62 705.664C-1009.83 729.379 -890.042 743.928 -770.25 705.664C-650.458 666.819 -661.619 542.572 -541.828 488.305C-422.036 433.457 -357.435 371.578 -237.643 371.141C4.68335 332.498 188.083 464.591 307.875 511.584C427.667 557.703 547.789 591.488 695.909 620.263C827.004 635.83 950.106 666.383 1069.9 620.263C1189.69 573.27 1266.21 543.154 1326.1 488.305L1386 434.038V806.488H1326.1C1266.21 806.488 1146.42 806.488 1026.62 806.488C906.833 806.488 787.042 806.488 667.25 806.488C547.458 806.488 427.667 806.488 307.875 806.488C188.083 806.488 68.2916 806.488 -51.5 806.488C-171.292 806.488 -291.083 806.488 -410.875 806.488C-530.667 806.488 -650.458 806.488 -770.25 806.488C-890.042 806.488 -1009.83 806.488 -1129.62 806.488C-1249.42 806.488 -1369.21 806.488 -1429.1 806.488H-1489V620.263Z",
    fill: "url(#paint1_linear_10033_38400)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 442.991L53.6433 448.68C107.287 454.37 182.164 468.379 253.688 510.163C355.946 556.443 459.88 639.541 589.518 661.962C686.746 696.87 858.293 718.969 965.58 683.383C1072.87 647.901 1334.38 792.34 1451.72 683.383C1559.01 703.452 1529.95 662.077 1585.27 639.541H1609.3V770.919H1555.66C1502.01 770.919 1394.73 770.919 1287.44 770.919C1180.15 770.919 1072.87 770.919 965.58 770.919C858.293 770.919 751.007 770.919 643.72 770.919C536.433 770.919 429.147 770.919 321.86 770.919C214.573 770.919 107.287 770.919 53.6433 770.919H0V442.991Z",
    fill: "url(#paint2_linear_10033_38400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 659.422L63.5 677.589C127 695.887 254 732.22 381 745.253C508 758.154 635 747.622 762 725.507C889 703.259 1016 669.558 1143 681.406C1270 693.254 1397 750.65 1524 750.65C1651 750.65 1778 693.254 1841.5 664.424L1905 635.726V823.975H1841.5C1778 823.975 1651 823.975 1524 823.975C1397 823.975 1270 823.975 1143 823.975C1016 823.975 889 823.975 762 823.975C635 823.975 508 823.975 381 823.975C254 823.975 127 823.975 63.5 823.975H0V659.422Z",
    fill: "#ECEDF1",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 572.847L33.0137 581.126C66.0275 589.095 131.862 606.117 198.275 630.644C264.014 655.635 330.138 688.131 395.587 700.743C462 712.89 528.412 705.153 593.862 688.363C659.986 671.883 725.725 647.124 792.137 634.744C857.972 622.365 924 622.365 990.412 626.466C1055.96 630.876 1122.28 638.613 1187.72 655.403C1254.04 671.883 1319.59 696.642 1353.28 709.021L1386 721.401V770.919H1352.99C1319.97 770.919 1254.14 770.919 1187.72 770.919C1121.99 770.919 1055.86 770.919 990.412 770.919C924 770.919 857.587 770.919 792.137 770.919C726.014 770.919 660.275 770.919 593.862 770.919C528.027 770.919 462 770.919 395.587 770.919C330.041 770.919 263.725 770.919 198.275 770.919C131.959 770.919 66.4125 770.919 32.725 770.919H0V572.847Z",
    fill: "url(#paint3_linear_10033_38400)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-217 688.036L-144.652 709.213C-72.3042 730.543 72.3917 772.897 217.087 788.089C361.783 803.128 506.479 790.851 651.175 765.071C795.871 739.137 940.567 699.852 1085.26 713.663C1229.96 727.474 1374.65 794.381 1519.35 794.381C1664.05 794.381 1808.74 727.474 1881.09 693.868L1953.44 660.415V879.855H1881.09C1808.74 879.855 1664.05 879.855 1519.35 879.855C1374.65 879.855 1229.96 879.855 1085.26 879.855C940.567 879.855 795.871 879.855 651.175 879.855C506.479 879.855 361.783 879.855 217.087 879.855C72.3917 879.855 -72.3042 879.855 -144.652 879.855H-217V688.036Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10033_38400",
    x1: 1448.5,
    y1: 782.828,
    x2: 1327.39,
    y2: 374.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10033_38400",
    x1: 73.9999,
    y1: 927.358,
    x2: 70.8254,
    y2: 262.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10033_38400",
    x1: 804.65,
    y1: 442.991,
    x2: 804.65,
    y2: 770.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10033_38400",
    x1: 788.5,
    y1: 871.809,
    x2: 785.326,
    y2: 472.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADBDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10033_38400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1386,
    height: 789,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave6);
export default __webpack_public_path__ + "static/media/wave6.45924b70f3065c08c4365d3e542bad31.svg";
export { ForwardRef as ReactComponent };